export default __webpack_public_path__ + "static/media/nucleo-icons.c82c9b7c.woff";